import { css } from "@emotion/react";
import { Theme, useTheme } from "@mui/material";

import QuestListItem from "~/components/me/bento/content/quest-log/QuestListItem";
import { filterActiveQuest } from "~/components/me/bento/content/quest-log/lib";
import { fixedWidth, flexColumn, flexRow } from "~/lib/client/design";
import { SP_MODE_WIDTH } from "~/lib/client/hooks/useIsSpMode";
import {
  MeQuestContentQuery,
  UserQuestProgressStatus,
} from "~/lib/graphql/client";

const DialogBody = ({ content }: { content: MeQuestContentQuery }) => {
  const theme = useTheme();
  const activeQuest = content.me.userQuestProgresses.filter(filterActiveQuest);
  const completeQuest = content.me.userQuestProgresses.filter(
    (progress) => progress.status === UserQuestProgressStatus.Verified
  );

  return (
    <div css={rootStyle}>
      <div css={listLabelAndCountStyle}>
        <p css={listLabelStyle}>In Progress</p>
        <p css={listCountStyle(theme, "primary")}>{activeQuest.length}</p>
      </div>

      <div css={questListStyle} role={"list"}>
        {activeQuest.map((progress) => (
          <QuestListItem key={progress.quest.id} progress={progress} />
        ))}
      </div>
      <div css={listLabelAndCountStyle}>
        <p css={listLabelStyle}>Completed</p>
        <p css={listCountStyle(theme, "secondary")}>{completeQuest.length}</p>
      </div>
      <div css={questListStyle} role={"list"}>
        {completeQuest.map((progress) => (
          <QuestListItem key={progress.quest.id} progress={progress} />
        ))}
      </div>
    </div>
  );
};

const rootStyle = css`
  ${fixedWidth("720px")};
  margin: 0 auto;

  @media (max-width: ${SP_MODE_WIDTH}px) {
    ${fixedWidth("100%")};
  }
`;

const listLabelStyle = css`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
`;

const listCountStyle = (theme: Theme, color: "primary" | "secondary") => css`
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  color: ${theme.palette[color].main};
`;

const listLabelAndCountStyle = css`
  ${flexRow};
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 1rem;
`;

const questListStyle = css`
  ${flexColumn};
  gap: 1rem;
  margin-top: 1rem;
`;

export default DialogBody;
